'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const removeBlanksAndNulls = (obj = {}) => {
  // eslint-disable-next-line no-param-reassign
  if (obj === null) obj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object')
      removeBlanksAndNulls(obj[key]);
    if (
      obj[key] === '' ||
      obj[key] === null ||
      (Array.isArray(obj[key]) && obj[key].length === 0)
    )
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
  });
  return obj;
};
exports.default = removeBlanksAndNulls;
